module.exports = __webpack_public_path__ + "static/media/arrow_left.a767c275.svg";